import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * ### **ValorationModalComponent**
 *
 * **Selector:** ``<app-valoration-modal>``
 *
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el Componente
 * encargado de renderizar el modal de valoración, ademas de permitir la edición del mismo.
 */
@Component({
  selector: 'app-valoration-modal',
  imports: [MatDialogModule, FormsModule, TranslateModule],
  templateUrl: "./valoration-modal.component.html",
  styleUrl: "./valoration-modal.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValorationModal {
  public readonly dialogRef = inject(MatDialogRef<ValorationModal>);

  public data: { detail: string } = inject(MAT_DIALOG_DATA);

  /** Variable que guardará la valoración(comentario).*/
  protected readonly detailV = signal<string>('');

  /**
   * Función encargada de incializar la variable detailV con los parametros que le llegan, además le da el contexto
   * al componente (modal).
   * @param dialogRef Parametro que se encarga de tratar al componente como un modal.
   * @param data Objeto que reciiibira los datos que son enviados al componente.
   */
  constructor() {
    this.detailV.set(this.data.detail);
  }

  /**
   * Función encargada de retornar el comentario actualizado una vez se ha cerrado el modal.
   */
  close(): void {
    this.dialogRef.close({ detail: this.detailV() });
  }
}
